export {default as path} from "./path";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/src/index.js
// module id = 181
// module chunks = 0